export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationContext {
  source?: string;
  operation?: string;
  method?: string;
  endpoint?: string;
  status?: number;
}

export interface NotificationData extends NotificationContext {
  type: NotificationType;
  title?: string;
  message: string;
  errors?: string[];
}

export interface SystemNotification extends NotificationData {
  id: number;
  createdAt: number;
  lastOccurredAt: number;
  occurrences: number;
  read: boolean;
}

export const NOTIFICATION_LABELS: Record<NotificationType, string> = {
  success: 'Succès', error: 'Erreur', warning: 'Attention', info: 'Information',
};

export const NOTIFICATION_ICONS: Record<NotificationType, string> = {
  success: 'check_circle', error: 'error', warning: 'warning', info: 'info',
};
